import { render, staticRenderFns } from "./templateconfig.vue?vue&type=template&id=d61f8a24&scoped=true&"
import script from "./templateconfig.vue?vue&type=script&lang=js&"
export * from "./templateconfig.vue?vue&type=script&lang=js&"
import style0 from "./templateconfig.vue?vue&type=style&index=0&id=d61f8a24&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61f8a24",
  null
  
)

export default component.exports